angular.module('lf.common')

.factory('lfFormSubmit', function ($http) {
  return function (form, success, error) {
    $http({
      method  : 'POST',
      url : form.attr('action'),
      data  : form.serialize(), // Not the Angular way, but ATG forms require it. Alternative would be to use the "handler.jsp" approach.
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' }  // set the headers so angular passing info as form data (not request payload)
    })
    .success(success || angular.noop)
    .error(error || angular.noop);
  }
});
